import { useInputHelper, DefaultInputPropTypes, TextInput } from 'framework/form';
import { ProjectLinkConfig, restrictedResourcesForPartialManage } from 'domain/shared/newProject';
import ProjectToolAutosuggestDropdown from './ProjectToolAutosuggestDropdown';
import { Grid2 as Grid } from '@mui/material';

interface ProjectToolInputProps extends Omit<DefaultInputPropTypes<unknown>, 'disabled'> {
  suggestions?: ProjectLinkConfig[];
  disabled?: boolean | ((values: any) => boolean);
  hasFullManageAccess?: boolean;
}

const ProjectToolInput = ({
  suggestions = [],
  disabled,
  hasFullManageAccess = true,
  ...props
}: ProjectToolInputProps) => {
  const { getSource, getValue } = useInputHelper(props);
  const source = getSource();
  const value = getValue();

  const isDisabled = typeof disabled === 'function' ? disabled(value) : !!disabled;

  const isFieldDisabled =
    isDisabled || (!hasFullManageAccess && restrictedResourcesForPartialManage.includes(value?.name));

  return (
    <Grid container size={{ xs: 12, md: 6 }} spacing={2} columns={{ md: 2, sm: 2, xs: 1 }}>
      <Grid size={1} sx={{ flexShrink: 1 }} direction="row">
        <ProjectToolAutosuggestDropdown
          source={`${source}.name`}
          suggestions={suggestions}
          label="Tool"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid size={1} sx={{ flexShrink: 1 }}>
        <TextInput source={`${source}.value`} label="Link" disabled={isFieldDisabled} />
      </Grid>
    </Grid>
  );
};

export default ProjectToolInput;
